import { EventPanelFormType } from '@mark43/cad-api';
import { useCallback } from 'react';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { FrPageHeader } from '../fr-page-layout/fr-page-header';

export function FrAddEventPropertyHeader() {
    const { form } = useIntegratedForm<EventPanelFormType>();

    const onGoBack = useCallback(() => {
        form.reset();
    }, [form]);

    return <FrPageHeader showGoBackButton onGoBack={onGoBack} title="Add Involved Property" />;
}
